import { Box, HStack, Text, useDisclosure, Button as ChakraButton, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import DetailsModal from "./DetailsModal";
import InputBlockMain from "./InputBlockMain";
import { Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { promptTestingCopyApi } from "../../../allApi/api";
import {
  promptTestingResponceFun,
  proptTestingLoadingFun,
} from "../../../redux/reducer/promptTestingReduce";
import { useDispatch, useSelector } from "react-redux";
import { useCustomTost } from "../../../utiils/useCustomTost";

function PromptInputTag({ formData, setFormData }) {
  const dispatch = useDispatch();
  const [errorset, setError] = useState({});
  const toast = useCustomTost();
  const proptSaveData = useSelector((state) => state.promptTesting.propmtSaveData);
  const [Userblocks, setUserBlocks] = useState([]);
  const [UserSystemblocks, setUserSystemblocks] = useState([]);
  const [isPromptSaved, setIsPromptSaved] = useState(false);

  const {
    isOpen: isConfirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();
  const cancelRef = useRef();

  const validation = () => {
    const err = {};
    if (!Userblocks || Userblocks?.length === 0) {
      err.userError = "User Message Require";
    }
    if (!formData.model || (typeof formData.model === "object" && Object.keys(formData.model).length === 0) || formData?.model === "") {
      err.model = "Please select Client";
    }
    if (!formData.selected_model || formData.selected_model === "") {
      err.selected_model = "Please select model";
    }
    setError(err);
    return err?.userError || err?.model || err?.selected_model ? true : false;
  };

  const handleComplete = async () => {
    if (validation()) {
      return;
    }
    dispatch(proptTestingLoadingFun(true));
    const formSessionId = localStorage.getItem("propt_id");
    const sessionId = formSessionId ? formSessionId : uuidv4();
    localStorage.setItem("propt_id", sessionId);
    try {
      const responce = await promptTestingCopyApi({
        ...formData,
        prompt: [...Userblocks],
        system_message: [...UserSystemblocks],
        session_id: sessionId,
      });
      dispatch(promptTestingResponceFun(responce));
      setIsPromptSaved(true);
    } catch (error) {
      toast("An error occurred.", error, "error");
    } finally {
      dispatch(proptTestingLoadingFun(false));
    }
  };

  const handleAddNewPrompt = () => {
    if (!isPromptSaved) {
      toast("Please save the current prompt before adding a new one.", "", "warning");
      return;
    }
    onConfirmOpen();
  };

  const confirmNewPrompt = () => {
    setUserBlocks([]);
    setUserSystemblocks([]);
    setFormData((prev) => ({
      ...prev,
      prompt: [],
      system_message: [],
    }));
    setIsPromptSaved(false);
    onConfirmClose();
  };

  useEffect(() => {
    if (proptSaveData) {
      setFormData({
        prompt: proptSaveData.query || ["hi", "hello"],
        system_message: proptSaveData.system_message || ["you are an agent"],
        model: proptSaveData.model_data || {},
        selected_model: "",
        tokens: proptSaveData?.max_tokens || 1024,
        temperature: proptSaveData?.temperature || 0.3,
        top_p: proptSaveData?.top_p || 0.9,
        json: false,
        session_id: proptSaveData?.session_id || "",
      });
    }
    setUserBlocks(proptSaveData.query || []);
    setUserSystemblocks(proptSaveData.system_message || []);
  }, [proptSaveData]);

  return (
    <Box h="100%" w="42%" border="1px solid #E4E4E7">
      <HStack justifyContent="space-between" p={2} borderBottom="1px solid #E4E4E7" h="50px">
        <Text fontWeight="bold">Prompt</Text>
        <HStack>
          <ChakraButton onClick={handleAddNewPrompt} size="sm" variant="outline" colorScheme="blue">
            +
          </ChakraButton>
          <Button onClick={handleComplete} size="sm">
            <HStack borderRadius="md" bg="black" p={1}>
              <Text color="white" fontWeight="bold">Run</Text>
            </HStack>
          </Button>
        </HStack>
      </HStack>

      <DetailsModal formData={formData} setFormData={setFormData} errorset={errorset} />
      <InputBlockMain
        Userblocks={Userblocks}
        setUserBlocks={setUserBlocks}
        UserSystemblocks={UserSystemblocks}
        setUserSystemblocks={setUserSystemblocks}
        formData={formData}
        setFormData={setFormData}
        errorset={errorset}
      />

      <AlertDialog
        isOpen={isConfirmOpen}
        leastDestructiveRef={cancelRef}
        onClose={onConfirmClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Add New Prompt
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to create a new prompt? Unsaved data will be lost.
            </AlertDialogBody>
            <AlertDialogFooter>
              <ChakraButton ref={cancelRef} onClick={onConfirmClose}>
                Cancel
              </ChakraButton>
              <ChakraButton colorScheme="blue" onClick={confirmNewPrompt} ml={3}>
                Confirm
              </ChakraButton>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}

export default PromptInputTag;
